export const EXCHANGE_CODE="EXCHANGE_CODE"
export const EXCHANGE_CODE_SUCCESS="EXCHANGE_CODE_SUCCESS"
export const EXCHANGE_CODE_FAILED="EXCHANGE_CODE_FAILED"